<script setup>
import { ref } from 'vue'
import { useCustomerStore } from '@/stores/customer'

const customerStore = useCustomerStore()

const props = defineProps({
  customer: {
    type: Object,
    default: () => ({})
  },
  customerName: {
    type: String
  },
  sharedData: {
    type: Object,
    default: () => ({})
  }
})

const customer = ref({ ...props.customer })

if (props.customerName && !customer.value.name) {
  customer.value.name = props.customerName
}

const emits = defineEmits(['close'])

const submit = async () => {
  const id = customer.value.id
    ? await customerStore.updateCustomer(customer.value)
    : await customerStore.createCustomer(customer.value)

  if (!id && !customer.value.id) return

  emits('close', id)
}
</script>

<template>
  <form @submit.prevent="submit">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col">
        <label for="name"> שם </label>
        <InputGroup>
          <InputText id="name" v-model.trim="customer.name" type="text" fluid autofocus />
          <Button
            v-if="props.sharedData?.name && props.sharedData.name !== customer.name"
            icon="pi pi-copy"
            severity="secondary"
            outlined
            v-tooltip.top="`העתק: ${props.sharedData.name}`"
            @click="customer.name = props.sharedData.name"
          />
        </InputGroup>
        <small
          v-if="props.sharedData?.name && props.sharedData.name !== customer.name"
          class="mt-1 text-gray-500 italic"
        >
          ערך משותף: {{ props.sharedData.name }}
        </small>
      </div>

      <div class="flex flex-col">
        <label for="phone"> טלפון </label>
        <InputGroup>
          <InputText
            id="phone"
            v-model.trim="customer.phone"
            type="text"
            fluid
            inputmode="tel"
            dir="ltr"
          />
          <Button
            v-if="props.sharedData?.phone && props.sharedData.phone !== customer.phone"
            icon="pi pi-copy"
            severity="secondary"
            outlined
            v-tooltip.top="`העתק: ${props.sharedData.phone}`"
            @click="customer.phone = props.sharedData.phone"
          />
        </InputGroup>
        <small
          v-if="props.sharedData?.phone && props.sharedData.phone !== customer.phone"
          class="mt-1 text-gray-500 italic"
        >
          ערך משותף: {{ props.sharedData.phone }}
        </small>
      </div>

      <div class="flex flex-col">
        <label for="email"> אימייל </label>
        <InputGroup>
          <InputText id="email" v-model.trim="customer.email" type="text" fluid inputmode="email" />
          <Button
            v-if="props.sharedData?.email && props.sharedData.email !== customer.email"
            icon="pi pi-copy"
            severity="secondary"
            outlined
            v-tooltip.top="`העתק: ${props.sharedData.email}`"
            @click="customer.email = props.sharedData.email"
          />
        </InputGroup>
        <small
          v-if="props.sharedData?.email && props.sharedData.email !== customer.email"
          class="mt-1 text-gray-500 italic"
        >
          ערך משותף: {{ props.sharedData.email }}
        </small>
      </div>

      <div class="flex flex-col">
        <label for="address"> כתובת </label>
        <InputGroup>
          <InputText id="address" v-model.trim="customer.address" type="text" fluid />
          <Button
            v-if="props.sharedData?.address && props.sharedData.address !== customer.address"
            icon="pi pi-copy"
            severity="secondary"
            outlined
            v-tooltip.top="`העתק: ${props.sharedData.address}`"
            @click="customer.address = props.sharedData.address"
          />
        </InputGroup>
        <small
          v-if="props.sharedData?.address && props.sharedData.address !== customer.address"
          class="mt-1 text-gray-500 italic"
        >
          ערך משותף: {{ props.sharedData.address }}
        </small>
      </div>

      <div class="flex flex-col">
        <label for="note"> הערה </label>
        <Textarea id="note" v-model.trim="customer.note" type="text" fluid autoResize />
        <div
          v-if="props.sharedData?.note && props.sharedData.note !== customer.note"
          class="mt-1 flex items-center gap-2"
        >
          <small class="flex-1 text-gray-500 italic">
            הערה משותפת: {{ props.sharedData.note }}
          </small>
          <Button
            icon="pi pi-plus"
            severity="secondary"
            text
            size="small"
            v-tooltip.top="`הוסף הערה מהשיתוף להערה הקיימת`"
            @click="
              customer.note = (customer.note ? customer.note + '\n' : '') + props.sharedData.note
            "
          />
        </div>
      </div>

      <div class="flex gap-4">
        <Button fluid severity="secondary" outlined label="ביטול" @click="$emit('close')" />
        <Button fluid label="שמירה" type="submit" :loading="customerStore.loading" />
      </div>
    </div>
  </form>
</template>
